import { render, staticRenderFns } from "./edu-switch-tip.vue?vue&type=template&id=aeeac9c8&scoped=true"
import script from "./edu-switch-tip.vue?vue&type=script&lang=js"
export * from "./edu-switch-tip.vue?vue&type=script&lang=js"
import style0 from "./edu-switch-tip.vue?vue&type=style&index=0&id=aeeac9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeac9c8",
  null
  
)

export default component.exports